import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const HIGHLIGHTS = [
  "A full wellbeing & lifestyle assessment",
  "Weekly one-to-one sessions — online or in Dubai",
  "A bio-individual nutrition framework, built for you",
  "Support between sessions, on WhatsApp",
];

const SECONDARY = [
  {
    t: "Foundational Balance",
    dur: "8 weeks",
    d: "Focused support for energy, stress resilience and everyday eating — for when life is full but manageable.",
  },
  {
    t: "Executive Energy Intensive",
    dur: "4 weeks",
    d: "A short, sharp sprint on sleep, focus and fuel, designed for demanding calendars.",
  },
];

export default function Programs() {
  return (
    <section id="programs" className="bg-cream py-28" data-testid="programs-section-b">
      <div className="max-w-[1360px] mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <Reveal>
            <h2 className="font-displayb font-light text-[clamp(2.4rem,5vw,4.2rem)] leading-[1.02]">
              Programs, made <em className="italic text-clay">for you</em>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-xs text-forest/60">One-to-one only. Every program starts with a free discovery call.</p>
          </Reveal>
        </div>

        <Reveal>
          <div
            data-testid="program-card-next-chapter"
            className="bg-forest text-cream rounded-[3rem] p-8 lg:p-16 grid lg:grid-cols-2 gap-12 relative overflow-hidden"
          >
            <div
              aria-hidden="true"
              className="absolute -bottom-32 -right-24 w-[440px] h-[440px] rounded-full bg-[radial-gradient(circle,rgba(122,140,116,0.25),transparent_65%)]"
            />
            <div className="relative">
              <span className="inline-flex items-center rounded-full border border-cream/30 px-4 py-1.5 text-xs uppercase tracking-[0.18em] text-cream/80">
                Flagship · 12 weeks · 1-on-1
              </span>
              <h3 className="mt-7 font-displayb font-light text-[clamp(2.6rem,5vw,4.4rem)] leading-[1]">
                Next <em className="italic text-clay">Chapter</em>
              </h3>
              <p className="mt-6 text-cream/75 text-lg leading-relaxed max-w-md">
                My signature twelve-week, one-to-one journey — a full reset for the season you're
                in. We rebuild the way you eat, move, sleep and recover, one doable habit at a time.
              </p>
              <a
                href="#contact"
                data-testid="program-cta-next-chapter"
                className="group mt-9 inline-flex items-center gap-3 rounded-full bg-cream text-forest pl-7 pr-3 py-3 font-semibold hover:bg-linen transition-colors"
              >
                Ask about Next Chapter
                <span className="grid place-items-center w-9 h-9 rounded-full bg-clay text-cream transition-transform duration-300 group-hover:rotate-45">
                  <ArrowUpRight size={17} />
                </span>
              </a>
            </div>
            <div className="relative">
              <p className="text-xs uppercase tracking-[0.22em] text-cream/50">What's inside</p>
              <ul className="mt-6">
                {HIGHLIGHTS.map((h) => (
                  <li
                    key={h}
                    className="flex items-start gap-4 py-5 border-b border-cream/15 last:border-none"
                  >
                    <span className="w-2.5 h-2.5 rounded-full bg-clay mt-2.5 shrink-0" />
                    <span className="text-cream/85 leading-relaxed">{h}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 mt-6">
          {SECONDARY.map((p, i) => (
            <Reveal key={p.t} delay={0.15 + i * 0.1}>
              <div
                data-testid={`program-card-${p.t.toLowerCase().replace(/\s+/g, "-")}`}
                className="h-full bg-cream border border-forest/15 rounded-[2rem] p-8 lg:p-10 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-lg"
              >
                <span className="font-displayb italic text-clay">{p.dur} · 1-on-1</span>
                <h4 className="mt-4 font-displayb text-2xl sm:text-3xl">{p.t}</h4>
                <p className="mt-3 text-forest/65 leading-relaxed">{p.d}</p>
                <a
                  href="#contact"
                  data-testid={`program-details-${p.t.toLowerCase().replace(/\s+/g, "-")}`}
                  className="mt-6 inline-flex items-center gap-2 font-semibold text-forest hover:gap-3.5 transition-all"
                >
                  Request details <ArrowUpRight size={17} />
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
